import { useExternalFeatureLayers } from 'features/mapping/hooks/useExternalFeatureLayers';
import { useMapContext } from 'features/mapping/components/Map/MapContext';
import { MapLayers } from 'features/mapping/mapping.constants';
import { ExternalFeatureLayer } from './ExternalFeatureLayer';

type AllExternalFeatureLayersProps = {
  interactive?: boolean;
};

export const AllExternalFeatureLayers = (
  props: AllExternalFeatureLayersProps = {},
): JSX.Element | null => {
  const { interactive } = props;
  const { externalFeatureLayers } = useExternalFeatureLayers();
  const { isLayerVisible } = useMapContext();

  if (!externalFeatureLayers.length) return null;

  return (
    <>
      {externalFeatureLayers
        .filter((featureLayer) => featureLayer.hasAnyFeatures)
        .map((featureLayer) => (
          <ExternalFeatureLayer
            key={featureLayer.mapLayerId}
            visible={isLayerVisible(featureLayer.mapLayerId, {
              policyKey:
                featureLayer.geomType === 'polygon'
                  ? MapLayers.TEAM_POLYGON_LAYER
                  : MapLayers.TEAM_LAYER,
            })}
            sourceId={featureLayer.mapLayerId}
            featureLayer={featureLayer}
            interactive={interactive}
          />
        ))}
    </>
  );
};
